import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation } from 'react-router-dom'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

import { FlowButton } from '../../components/FlowButton'
import { FlowFeedbackPopup } from '../../components/FlowFeedbackPopup'
import { FlowPageContainer } from '../../components/FlowPageContainer'
import { useCancelSubscription } from '../../hooks/useCancelSubscription'
import { useRetentionFlowV2Config } from '../../hooks/useRetentionFlowV2Config'
import { FlowContent } from '../../styles'
import { StyledFlowCancelConfirmation as S } from './FlowCancelConfirmation.styles'

export const FlowCancelConfirmation: React.FC = () => {
  const { search } = useLocation()
  const { t } = useTranslation()
  const { copyKey } = useRetentionFlowV2Config()
  const {
    isCancelConfirmationShown,
    isFeedbackPopupShown,
    askFeedback,
    closeFeedbackPopup,
    cancelSubscription,
  } = useCancelSubscription()

  const keepSubscription = () => {
    goTo(
      { pathname: PageId.CONTINUED_SUBSCRIPTION, search },
      { isPlanKept: true },
    )
  }

  if (!isCancelConfirmationShown) {
    return (
      <Navigate
        to={{ pathname: `/${PageId.SUBSCRIPTION_DETAILS}`, search }}
        replace
      />
    )
  }

  return (
    <FlowPageContainer hasNavigation>
      <FlowContent>
        <S.Title>{t(`${copyKey}.cancelConfirmation.title`)}</S.Title>
        <S.Description>
          {t(`${copyKey}.cancelConfirmation.description`)}
        </S.Description>
        <S.Losses>
          {(
            t(`${copyKey}.cancelConfirmation.losses`, {
              returnObjects: true,
            }) as string[]
          ).map((text) => (
            <S.Loss key={text}>{text}</S.Loss>
          ))}
        </S.Losses>
        <S.Buttons>
          <FlowButton type="button" onClick={keepSubscription}>
            {t(`${copyKey}.cancelConfirmation.keepPlan`)}
          </FlowButton>
          <FlowButton type="button" variant="secondary" onClick={askFeedback}>
            {t(`${copyKey}.cancelConfirmation.cancelPlan`)}
          </FlowButton>
        </S.Buttons>
      </FlowContent>
      <FlowFeedbackPopup
        isShown={isFeedbackPopupShown}
        onComplete={cancelSubscription}
        onClose={closeFeedbackPopup}
      />
    </FlowPageContainer>
  )
}
